import { render, staticRenderFns } from "./main.vue?vue&type=template&id=62518ecc"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62518ecc')) {
      api.createRecord('62518ecc', component.options)
    } else {
      api.reload('62518ecc', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=62518ecc", function () {
      api.rerender('62518ecc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/packages/element/notification/src/main.vue"
export default component.exports